import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconApiConnection: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconApiConnection"><Path d="M3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C15.498 20.25 18.4875 18.073 19.6876 15M3.75 12C3.75 7.44365 7.44365 3.75 12 3.75C15.498 3.75 18.4875 5.92698 19.6876 9M3.75 12H1.75M17.25 12C17.25 14.8995 14.8995 17.25 12 17.25C9.10051 17.25 6.75 14.8995 6.75 12C6.75 9.10051 9.10051 6.75 12 6.75C14.8995 6.75 17.25 9.10051 17.25 12ZM17.25 12H22.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconApiConnection;
